import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { DocumentsListViewModel } from '@/features/docs/DocumentsListViewModel'

/**
 * View model for the documents screen.
 */
export class DocumentsViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  constructor(public readonly listVm: DocumentsListViewModel) {
    this._lifecycle.manage(this.listVm)
  }

  activate() {
    this._lifecycle.activate()
    void this.listVm.fetch(this._lifecycle.signal)
  }

  deactivate() {
    this._lifecycle.deactivate()
  }
}
